import { LitElement as O, unsafeCSS as x } from "lit";
import { query as L, property as i, state as _ } from "lit/decorators.js";
import { classMap as k } from "lit/directives/class-map.js";
import { unsafeHTML as D } from "lit/directives/unsafe-html.js";
import { unsafeStatic as E, literal as A, html as b } from "lit/static-html.js";
import { getCustomElementSuffix as V } from "../../api/custom-element-scope.js";
import { highlightTextMultiple as R, highlightText as q } from "../../api/marker/marker.js";
import z from "../../api/marker/marker.style.css.js";
import { normalizeText as g } from "../../utils/helpers.js";
import { booleanType as f, booleanConverter as v } from "../../utils/property-types.js";
import B from "./searchbar.style.css.js";
import { template as M } from "./searchbar.template.js";
var U = Object.defineProperty, s = (F, t, r, o) => {
  for (var a = void 0, p = F.length - 1, d; p >= 0; p--)
    (d = F[p]) && (a = d(t, r, a) || a);
  return a && U(t, r, a), a;
};
const I = A`dss-icon${E(V())}`, $ = A`dss-chip${E(V())}`, T = class T extends O {
  constructor() {
    super(), this.value = "", this.multiple = !1, this.icon = "search", this.size = "lg", this.helpText = void 0, this.innerFocus = !1, this.threshold = 3, this.searchTerms = [], this.searchItems = [], this.catalog = [], this.emptyDropdownText = "Sense resultats per", this.recentSearchesLabel = "Últimes cerques", this.recentSearches = !1, this.isCatalogLoading = !1, this.dropdownStyle = "", this.catalogStyle = "", this.advancedFilter = !1, this.placeholder = "Escriu per cercar", this._filter = "", this._isFocused = !1, this._showClearButton = !1, this._filteredCatalog = [], this._showAllChips = !1, this._showDropdown = !1, this._dropdownStyle = "", this.id = "", this.name = "", this.label = "Cercador", this.disabled = !1, this.readonly = !1, this.required = !1, this.invalid = !1, this.autocapitalize = "none", this.autocomplete = "off", this.autocorrect = !1, this.autofocus = !1, this.spellcheck = !1, this._defaultId = `dss-input-${crypto.randomUUID()}`, this.tooltipFixed = !1, this.forceViewport = !1, this._isTruncated = !1, this._isCatalogLoaded = !1, this._lastValue = null, this.internals = this.attachInternals();
  }
  static get styles() {
    return [x(z), x(B)];
  }
  formDisabledCallback(t) {
    this.disabled = t;
  }
  formResetCallback() {
    this.value = "", this._input.value = "";
  }
  formStateRestoreCallback(t) {
    this.value = t ?? "", this._input.value = t ?? "";
  }
  updated(t) {
    t.has("value") && (this.internals.setFormValue(this.value), this.requestUpdate()), t.has("catalog") && queueMicrotask(() => {
      if (!this._isCatalogLoaded) {
        this._isCatalogLoaded = !0;
        return;
      }
      this._filter.length >= this.threshold && (this._filteredCatalog = this._getFilterCatalog(this._filter));
    });
  }
  _getEffectiveId() {
    return this.id !== "" ? this.id : this._defaultId;
  }
  _getSearchStyle() {
    return `top: ${this.renderRoot.querySelectorAll(".dss-search-bar")[0].offsetHeight + 4}px; ${this.dropdownStyle}`;
  }
  get _inputValidity() {
    var t;
    return this._input && this._input.value !== "" ? (t = this._input) == null ? void 0 : t.checkValidity() : !0;
  }
  _handleInput() {
    this.multiple || this._handleValidity(), this.value = this._input.value, this._filter = this._input.value;
    const t = this._input.value;
    if (t.length >= this.threshold) {
      if (this._showDropdown = !0, this._filteredCatalog = this._getFilterCatalog(t), this.multiple && t.endsWith(",")) {
        const o = t.slice(0, -1);
        this.searchTerms.push(o), this._input.value = "", this.searchTerms.length && this._dispatchSearchChange();
      }
      this._dropdownStyle = this._getSearchStyle();
    } else
      this._hideDropdown();
    this._emitInput();
  }
  _handleFocusIn() {
    this._isFocused = !0, this._showClearButton = !0;
  }
  _handleFocusOut() {
    this._isFocused = !1, this._showClearButton = !1, this._lastValue !== this._input.value && (this._checkInputOverflow(), this._lastValue = this._input.value);
  }
  _handleKeyDown(t) {
    (t == null ? void 0 : t.key) === "Enter" ? (this._showDropdown = !0, !this.multiple && this._input.value !== "" && (this.searchTerms = [], this.searchTerms.push(this._input.value), this._dispatchSearchChange(), this._showDropdown = !1), this._dropdownStyle = this._getSearchStyle()) : (t == null ? void 0 : t.key) === "Escape" && (this._showDropdown = !1);
  }
  _focusInput() {
    var t;
    (t = this._input) == null || t.focus();
  }
  _handleValidity() {
    var r;
    const t = (r = this._input) == null ? void 0 : r.checkValidity();
    this.invalid = !t, this.internals.setValidity(this._input.validity, this._input.validationMessage, this._input);
  }
  _clearSearch() {
    this._input && (this._input.value = "", this._input.focus(), this._lastValue !== this._input.value && (this._checkInputOverflow(), this._lastValue = this._input.value)), this.searchTerms = [], this.searchItems = [], this._dispatchSearchChange(), this._hideDropdown();
  }
  _hideDropdown() {
    this._showDropdown = !1, this._filteredCatalog = [];
  }
  _getFilterCatalog(t) {
    return this.advancedFilter ? this._applyAdvancedFilter(t) : this._applyDefaultFilter(t);
  }
  _applyDefaultFilter(t) {
    const r = g(t);
    return this.catalog.filter((o) => g(o.value).includes(r));
  }
  _applyAdvancedFilter(t) {
    if (!g(t.trim())) return this.catalog;
    const o = g(t).split(/\s+/).filter((a) => a.length >= this.threshold);
    return o.length === 0 ? this.catalog : this.catalog.filter((a) => {
      const p = g(a.value);
      return o.every((d) => p.includes(d));
    });
  }
  _generateSearchChips() {
    let t = 0;
    return this.searchTerms.map((o) => {
      var m;
      const a = (w) => {
        const S = w.detail.text;
        this.searchTerms = this.searchTerms.filter((C) => C !== S), this._dispatchSearchChange();
      };
      t += 1;
      const p = {
        disabled: this.disabled || this.readonly,
        "dss-chip--selected": !this.disabled && !this.readonly,
        "dss-chip--hide": t > 5
      };
      return b`
				<${$}
 					class="${k(p)}"
					size="sm" 
					label="${o}" 
					selected 
					disableSelect
					hasdelete 
					?disabled=${(m = this._input) == null ? void 0 : m.disabled}
					@onDelete="${a}">
				</${$}>
      `;
    });
  }
  _generateFilterCatalog() {
    let t = !0;
    return this._filteredCatalog.map((o) => {
      const a = (l) => {
        const c = l.target, h = c == null ? void 0 : c.closest("[value]"), n = h == null ? void 0 : h.getAttribute("value");
        n && (this.multiple ? this.searchTerms.includes(n) ? (this.searchTerms = this.searchTerms.filter((u) => u !== n), o.data && (this.searchItems = this.searchItems.filter((u) => u !== o.data))) : (this.searchTerms.push(n), o.data && this.searchItems.push(o.data)) : (this._input.value = n, this._showDropdown = !1, this.searchTerms = [], this.searchTerms.push(n), o.data && (this.searchItems = [], this.searchItems.push(o.data))), this._dispatchSearchChange(o));
      }, p = (l) => {
        l && l.focus();
      }, d = (l) => {
        let c = 0;
        const h = this.renderRoot.querySelectorAll(".dss-catalog-item"), n = h.length - 1;
        l === h[0] ? p(h[n]) : (h.forEach((y, u) => {
          y === l && (c = u);
        }), p(h[c - 1]));
      }, m = (l) => {
        let c = 0;
        const h = this.renderRoot.querySelectorAll(".dss-catalog-item"), n = h.length - 1;
        l === h[n] ? p(h[0]) : (h.forEach((y, u) => {
          y === l && (c = u);
        }), p(h[c + 1]));
      }, w = (l) => {
        const c = l.currentTarget, h = l;
        let n = !1;
        switch (h.key) {
          case "ArrowUp":
            d(c), n = !0;
            break;
          case "ArrowDown":
            m(c), n = !0;
            break;
          case "Enter": {
            const y = l.target, u = this.renderRoot.querySelector('.dss-catalog-item[tabindex="0"]');
            u == null || u.setAttribute("tabindex", "-1"), l.target.setAttribute("tabindex", "0"), y.click(), n = !0;
            break;
          }
        }
        n && (l.stopPropagation(), l.preventDefault());
      }, S = {
        "dss-catalog-item--selected": this.searchTerms.includes(o.value)
        // 'disabled': this._input?.disabled,
        // 'dss-chip--selected': !this._input?.disabled,
      }, C = b`
        <div
					role="option"
          class="dss-catalog-item ${k(S)}"
          value="${o.value}"
          tabindex="${t ? 0 : -1}"
          @click="${a}"
          @keydown=${w}
        >
          ${o.icon ? b`
								<${I}
									class="dss-catalog-item__icon"
									icon="${o.icon}"
									size="md"
									value="${o.value}"
								></${I}>
              ` : null}
          <div class="dss-catalog-item__text" value="${o.value}">
            ${this.advancedFilter ? D(R(o.value, this._filter, this.threshold)) : D(q(o.value, this._filter))}
					</div>
        </div>
      `;
      return t = !1, C;
    });
  }
  _dispatchSearchChange(t) {
    let r = {};
    t && t.data ? r = {
      values: this.searchTerms,
      selectedItems: this.searchItems
    } : r = this.searchTerms;
    const o = {
      detail: r,
      bubbles: !0,
      composed: !0
    };
    this.dispatchEvent(new CustomEvent("search", o)), this.multiple ? this.value = this.searchTerms.toString() : this.value = this.searchTerms[0] || "", this._emitChange();
  }
  _emitInput() {
    !this._input || this.multiple || (this.dispatchEvent(new Event("input", { bubbles: !0, composed: !0 })), this._handleChange());
  }
  _handleChange() {
    !this._input || this.multiple || this._emitChange();
  }
  _emitChange() {
    this.dispatchEvent(new Event("change", { bubbles: !0, composed: !0 }));
  }
  _closeDropdown() {
    document.addEventListener("mousedown", (t) => {
      t.target !== this && t.target !== this._input && (this._showDropdown = !1);
    }), document.addEventListener("focusout", (t) => {
      const r = t.relatedTarget;
      r !== null && r !== this && r !== this._input && (this._showDropdown = !1);
    });
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this._input && (this._closeDropdown(), this._dropdownStyle = this._getSearchStyle());
    } catch {
      console.error("ERROR OCURRED");
    }
  }
  _handleMouseOver() {
    var t, r;
    ((t = this._input) == null ? void 0 : t.value) !== this._lastValue && (this._checkInputOverflow(), this._lastValue = ((r = this._input) == null ? void 0 : r.value) || null);
  }
  _checkInputOverflow() {
    var d;
    if (this.multiple) {
      this._isTruncated = !1;
      return;
    }
    if (!this._input) return;
    const t = window.getComputedStyle(this._input), r = `${t.fontWeight} ${t.fontSize} ${t.fontFamily}`, a = document.createElement("canvas").getContext("2d");
    if (!a) return;
    a.font = r;
    const p = a.measureText(this._input.value).width;
    this._isTruncated = p > this._input.offsetWidth, this._isTruncated && ((d = this.shadowRoot) == null ? void 0 : d.querySelector(".dss-input-tooltip")).updateTooltip();
  }
  focus(t) {
    if (this._input) {
      this._input.focus(t);
      return;
    }
    this.updateComplete.then(() => {
      var r;
      (r = this._input) == null || r.focus(t);
    });
  }
  render() {
    return M(this);
  }
};
T.formAssociated = !0;
let e = T;
s([
  L("input.dss-input")
], e.prototype, "_input");
s([
  i({ type: String })
], e.prototype, "value");
s([
  i(f)
], e.prototype, "multiple");
s([
  i({ type: String })
], e.prototype, "icon");
s([
  i({ type: String })
], e.prototype, "size");
s([
  i({ type: String })
], e.prototype, "helpText");
s([
  i(f)
], e.prototype, "innerFocus");
s([
  i({ type: Number })
], e.prototype, "threshold");
s([
  i({ type: Array })
], e.prototype, "searchTerms");
s([
  i({ type: Array })
], e.prototype, "searchItems");
s([
  i({ type: Array })
], e.prototype, "catalog");
s([
  i({ type: String })
], e.prototype, "emptyDropdownText");
s([
  i({ type: String })
], e.prototype, "recentSearchesLabel");
s([
  i(f)
], e.prototype, "recentSearches");
s([
  i(f)
], e.prototype, "isCatalogLoading");
s([
  i({ type: String })
], e.prototype, "dropdownStyle");
s([
  i({ type: String })
], e.prototype, "catalogStyle");
s([
  i(f)
], e.prototype, "advancedFilter");
s([
  i({ type: String })
], e.prototype, "placeholder");
s([
  _()
], e.prototype, "_filter");
s([
  _()
], e.prototype, "_isFocused");
s([
  _()
], e.prototype, "_showClearButton");
s([
  _()
], e.prototype, "_filteredCatalog");
s([
  _()
], e.prototype, "_showAllChips");
s([
  _()
], e.prototype, "_showDropdown");
s([
  _()
], e.prototype, "_dropdownStyle");
s([
  i({ type: String })
], e.prototype, "id");
s([
  i({ type: String })
], e.prototype, "name");
s([
  i({ type: String })
], e.prototype, "label");
s([
  i({ converter: v, reflect: !0 })
], e.prototype, "disabled");
s([
  i({ converter: v, reflect: !0 })
], e.prototype, "readonly");
s([
  i({ converter: v, reflect: !0 })
], e.prototype, "required");
s([
  i({ converter: v, reflect: !0 })
], e.prototype, "invalid");
s([
  i({ type: String })
], e.prototype, "pattern");
s([
  i({ type: String })
], e.prototype, "inputmode");
s([
  i({ type: String })
], e.prototype, "autocapitalize");
s([
  i({ type: String })
], e.prototype, "autocomplete");
s([
  i(f)
], e.prototype, "autocorrect");
s([
  i(f)
], e.prototype, "autofocus");
s([
  i(f)
], e.prototype, "spellcheck");
s([
  i(f)
], e.prototype, "tooltipFixed");
s([
  i(f)
], e.prototype, "forceViewport");
s([
  _()
], e.prototype, "_isTruncated");
export {
  e as SearchBar_
};
//# sourceMappingURL=searchbar.js.map
